import { render, staticRenderFns } from "./AccountResetPasswordSuccess.vue?vue&type=template&id=895667be&scoped=true&"
import script from "./AccountResetPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./AccountResetPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AccountResetPasswordSuccess.vue?vue&type=style&index=0&id=895667be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895667be",
  null
  
)

export default component.exports